export enum ACR {
  LOA_SUBSTANTIAL_RISK_MEDIUM = 'https://eid.resurs.com/acrs/loa_substantial_risk_medium',
  LOA_SUBSTANTIAL_RISK_LOW = 'https://eid.resurs.com/acrs/loa_substantial_risk_low',
  LOA_HIGH_RISK_MEDIUM = 'https://eid.resurs.com/acrs/loa_high_risk_medium',
  LOA_HIGH_RISK_LOW = 'https://eid.resurs.com/acrs/loa_high_risk_low',
}
